import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';
import { FormattedMessage } from 'react-intl';
import PhoneIcon from 'dibs-vg/dist/react/phone';

import PdpSharedCallDealerModalLoader from './PdpSharedCallDealerModal/PdpSharedCallDealerModalLoader';
import PdpSharedFollowDealer from '../../mutations/PdpSharedFollowDealer';
import LoginCheck from '../../global/LoginCheck/LoginCheck';

import styles from './PdpSharedCallDealerCta.scss';

export class PdpSharedCallDealerCta extends React.Component {
    constructor() {
        super();
        this.state = {
            isModalOpen: false,
            userId: null,
        };

        this.onAuthSuccess = this.onAuthSuccess.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onCallDealerModalFollow = this.onCallDealerModalFollow.bind(this);
    }

    onAuthSuccess({ userId }) {
        this.setState({
            isModalOpen: true,
            userId,
        });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    onCallDealerModalFollow() {
        const { userId } = this.state;
        const { item: { seller }, relay } = this.props;
        const favoriteId = get(seller, 'favoritesByUser[0].serviceId', null);
        if (favoriteId) {
            // just close modal if seller already favorited
            this.closeModal();
        } else {
            PdpSharedFollowDealer.commit(relay.environment, {
                userId,
                sellerId: seller.id,
                sellerPk: seller.serviceId,
                favoriteId,
                onCompleted: (payload, errors) => {
                    if (!errors) {
                        this.closeModal();
                    }
                },
            });
        }
    }

    render() {
        const { isModalOpen, userId } = this.state;
        const { item, item: { seller } } = this.props;
        const itemId = get(item, 'serviceId');
        const telephone = get(seller, 'trackedPhone.phoneNumber');
        const linkChildren = (
            <Fragment>
                <PhoneIcon className={styles.phoneIcon} />
                <FormattedMessage
                    id="PdpSharedCallDealerCta.cta_link"
                    defaultMessage="Call seller through 1stdibs"
                />
            </Fragment>
        );

        return telephone ? (
            <Fragment>
                <LoginCheck
                    linkProps={{ children: linkChildren }}
                    onSuccess={this.onAuthSuccess}
                    link
                />
                {userId && (
                    <PdpSharedCallDealerModalLoader
                        userId={userId}
                        itemId={itemId}
                        isOpen={isModalOpen}
                        handleCloseClick={this.closeModal}
                        onFollowDealer={this.onCallDealerModalFollow}
                        location="pdp"
                    />
                )}
            </Fragment>
        ) : null;
    }
}

PdpSharedCallDealerCta.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedCallDealerCta, {
    item: graphql`
        fragment PdpSharedCallDealerCta_item on Item {
            serviceId
            seller {
                id
                serviceId
                favoritesByUser(userIds: $userId) @include(if: $fetchUser) {
                    serviceId
                }
                trackedPhone {
                    phoneNumber
                }
            }
        }
    `,
});
